import { lazy } from 'react';

// project imports
import GuestGuard from 'utils/route-guard/GuestGuard';
import MinimalLayout from 'layout/MinimalLayout';
import NavMotion from 'layout/NavMotion';
import Loadable from 'ui-component/Loadable';
import Error from 'views/pages/maintenance/Error';
import VerifyEmail from 'views/pages/authentication/VerifyEmail';

// login routing
const AuthLogin = Loadable(lazy(() => import('views/pages/authentication/Login')));
const AuthForgotPassword = Loadable(lazy(() => import('views/pages/authentication/ForgotPassword')));
const AuthCodeVerificarion = Loadable(lazy(() => import('views/pages/authentication/CodeVerification')));
const AppResetPassword = Loadable(lazy(() => import('views/pages/authentication/ResetPassword')));
const AuthRegister = Loadable(lazy(() => import('views/pages/authentication/Register')));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
    path: '/',
    element: (
        <NavMotion>
            <GuestGuard>
                <MinimalLayout />
            </GuestGuard>
        </NavMotion>
    ),
    children: [
        {
            path: '/',
            element: <AuthLogin />
        },
        {
            path: '/login',
            element: <AuthLogin />
        },
        {
            path: '/register',
            element: <AuthRegister />
        },
        {
            path: '/verify-email',
            element: <VerifyEmail />
        },
        {
            path: '/forgot',
            element: <AuthForgotPassword />
        },
        {
            path: '/code-verify',
            element: <AuthCodeVerificarion />
        },
        {
            path: '/reset-password',
            element: <AppResetPassword />
        },
        {
            path: '*',
            element: <Error />
        }
    ]
};

export default LoginRoutes;
